export default __webpack_public_path__ + "static/media/break22.6b27ef53.jpg";